import React from 'react';
import Col from 'react-bootstrap/lib/Col';

const PexCookiePolicy = function (props) {
  return <Col md={props.colMd} className="privacy-policy">
    <a href="https://s3-eu-west-1.amazonaws.com/pexcdn/PEX_Cookie_Policy.pdf" target="_blank" className="pull-right">PEX Cookie Policy</a></Col>;
};

export default PexCookiePolicy;
